export const SUPPORT_WHATSAPP_NUMBER = "447593308428";
export const ENQUIRY_RESPONSE_TIME = "Usually within an hour during UK daytime. Overnight requests may take up to 8 hours.";

export function formatQuotePickupTime(value) {
  if (!value) return "To be confirmed";
  const civil = typeof value === "string" && /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(value);
  const date = new Date(civil ? value.replace(" ", "T") + "Z" : value);
  if (Number.isNaN(date.getTime())) return "To be confirmed";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: civil ? "UTC" : "Europe/London", day: "numeric", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  }).format(date) + " (UK time)";
}

export function buildWhatsAppQuoteUrl({ pickup, dropoff, pickupTime, vehicle, quoteId, brand = "minibusgrab", passengers, bags, returnRequested, notes, handoffReference }) {
  const supportName = { ccg: "CheapCabGrab", minibusgrab: "Minibus", cheapcoachgrab: "Coach" }[brand] || "Journey";
  const message = [`Hi ${supportName} Support,`, "", "Please quote for:",
    `Pickup: ${pickup || "To be confirmed"}`,
    `Drop-off: ${dropoff || "To be confirmed"}`,
    `Date/time: ${formatQuotePickupTime(pickupTime)}`,
    `Vehicle: ${vehicle || "To be confirmed"}`,
    ...(passengers != null ? [`Passengers: ${passengers}`] : []),
    ...(bags != null ? [`Bags: ${bags}`] : []),
    ...(returnRequested ? ["Return journey requested — please confirm details"] : []),
    ...(notes ? [`Notes: ${String(notes).slice(0, 1500)}`] : []),
    `Reference: ${quoteId || "To be confirmed"}`,
    ...(handoffReference ? [`Handoff: ${handoffReference}`] : []), "", "Thanks!"].join("\n");
  return `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
